/**
 * What to send for a write-only field: the empty string to clear it, a null to leave it alone, or
 * the new value.
 *
 * <p>
 * <strong>Its own module because it is the rule that stops a Save wiping three documents, and that
 * rule is invisible from both ends.</strong> A PAN, an Aadhaar and a salary account are encrypted on
 * the way in and no endpoint will read one back — so the edit drawer renders them as empty boxes
 * over a "•••• 4321 on file" hint. The server reads a null as *leave what is stored alone* and an
 * empty string as *clear it*; an untouched text input produces the empty string. Sent as typed,
 * opening the drawer and pressing Save would clear every document on the row, which is the failure
 * `UpdateEmployeeRequest`'s own remarks name.
 * </p>
 *
 * <p>
 * So typing nothing becomes a null, and clearing has to be <em>said</em> — which is what the drawer's
 * tick box is for.
 * </p>
 */
export function keepOrReplace(
  typed: string | null | undefined,
  clear: boolean | undefined,
): string | null {
  if (clear) {
    return '';
  }

  const value = (typed ?? '').trim();

  return value === '' ? null : value;
}
